import { connect } from 'react-redux'
import PlayInDrawer from './PlayInDrawer'
import playInActions from '../../dataStore/actions/playIns'
import { showPlayInModal, closePlayInMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import constants from '@bt-react/constants'
import { State } from '../../dataStore/reducers/reducerType'
import { PlayInDrawerProps } from './types'
import { setAutoSpotlight } from '../../dataStore/actions/room/room'

type DispatchProps = 'onVideoClick' | 'showPlayInModal' | 'onClick'

const mapStateToProps = (state: State): Omit<PlayInDrawerProps, DispatchProps> => ({
  hidden: state.ui.selectedDrawer !== constants.drawerType.PLAY_IN,
  items: state.playIn.playInDetails,
  playIn: state.room.playIn,
  presenterLayoutActive: state.layouts.presenterLayout.presenterLayoutsActive
})
const mapDispatchToProps = (dispatch): Pick<PlayInDrawerProps, DispatchProps> => ({
  onVideoClick: (playIn, presenterLayoutActive) => {
    dispatch(playInActions.videoSelect(playIn))
    if (!presenterLayoutActive) dispatch(setAutoSpotlight(true))
  },
  showPlayInModal: () => dispatch(showPlayInModal()),
  onClick: () => dispatch(closePlayInMediaDrawer())
})

export default connect(mapStateToProps, mapDispatchToProps)(PlayInDrawer)
